import BeFirstInLineBanner from "./BeFirstInLineBanner";

export default BeFirstInLineBanner;
